import { environment } from "@environments/environment";

export const ROUTE_URL = {
  loginAppURL: environment.routeFolderPath + "login",
  homeAppURL: environment.routeFolderPath + "home",
  editReportAppURL: environment.routeFolderPath + "reports/edit",
  viewReportAppURL: environment.routeFolderPath + "reports/view",
  dashboardsAppURL: environment.routeFolderPath + "dashboards",
  editDashboardAppURL: environment.routeFolderPath + "dashboards/edit",
  viewDashboardAppURL: environment.routeFolderPath + "dashboards/view",
};
